import '../scss/main.scss';

// /* Core
// ------------------------------------------------- */
// import '../scss/core/_sanitize.scss';
// import '../scss/core/_fonts.scss';

// /* Settings
// ------------------------------------------------- */
// import '../scss/settings/_breakpoints.scss';
// import '../scss/settings/_colors.scss';
// import '../scss/settings/_easings.scss';
// import '../scss/settings/_sizing.scss';
// import '../scss/settings/_typography.scss';
// import '../scss/settings/_z-index.scss';

// /* Mixins
// ------------------------------------------------- */
// import '../scss/mixins/_autofill.scss';
// import '../scss/mixins/_clearfix.scss';
// import '../scss/mixins/_font.scss';
// import '../scss/mixins/_placeholder.scss';
// import '../scss/mixins/_pos.scss';
// import '../scss/mixins/_size.scss';
// import '../scss/mixins/_responsive-value.scss';
// import '../scss/mixins/_poly-fluid-sizing.scss';

// /* Keyframes
// ------------------------------------------------- */
// import '../scss/keyframes/_fadeInDown.scss';
// import '../scss/keyframes/_fadeInUp.scss';
// import '../scss/keyframes/_fadeOutDown.scss';
// import '../scss/keyframes/_fadeOutUp.scss';

// /* Elements
// ------------------------------------------------- */
// import '../scss/elements/_body.scss';
// import '../scss/elements/_heading.scss';
// import '../scss/elements/_html.scss';
// import '../scss/elements/_a.scss';
// import '../scss/elements/_input.scss';
// import '../scss/elements/_p.scss';
// import '../scss/elements/_select.scss';
// import '../scss/elements/_ul.scss';




// WEBPACK FOOTER //
// ./mysite/resources/js/styles.js